import { SPRITE_VERSION } from '@/icons/sprite-version.generated'

// Single source of truth for the sprite URL. The ?v= query busts the browser
// cache whenever the sprite content changes, despite the 1-week max-age on
// /icons/:path* in next.config.mjs — the header matcher matches the path only,
// so the query string is ignored for caching purposes. Both the preload in
// (app)/layout.tsx and the <use> in Icon.tsx MUST import this; versioning only
// one would make the preloaded URL and the actual fetch diverge (wasted preload
// + still-stale icons).
export const SPRITE_HREF = `/icons/sprite.svg?v=${SPRITE_VERSION}`
